// ----------------------------------------------------------------------
// <copyright file="Izenda.RowSpanCell.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Cell from './Izenda.TableCell';
import { assign, flow, noop } from 'lodash/fp';

@observer
export default class RowSpanCell extends Component {
  static propTypes = {
    rowSpan: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    fnGetCellStyle: PropTypes.func,
    fnGetCellContentStyle: PropTypes.func,
    cell: PropTypes.func,
    index: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.buildFn(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fnGetCellStyle !== nextProps.fnGetCellStyle) {
      this.buildFn(nextProps);
    }
  }

  injectHeigth = (style = {}) => {
    const { height } = this.props;
    return height ? assign(style, { height }) : style;
  };

  injectMaxHeigth = (style = {}) => {
    const { height } = this.props;
    return height ? assign(style, { maxHeight: height }) : style;
  };

  injectWidth = (style = {}) => {
    const { width } = this.props;
    return width ? assign(style, { width, minWidth: width, maxWidth: width }) : style;
  };

  buildFn = props => {
    this.fnGetCellStyle = flow(props.fnGetCellStyle || noop, this.injectWidth, this.injectHeigth);
    this.fnGetCellContentStyle = flow(props.fnGetCellContentStyle || noop, this.injectMaxHeigth);
  };

  render() {
    const { cell, rowSpan, index, handleItemClick, selectCell, sourceForm } = this.props;

    return (
      <Cell
        cell={cell}
        rowData={rowSpan}
        fnGetCellStyle={this.fnGetCellStyle}
        fnGetCellContentStyle={this.fnGetCellContentStyle}
        columnIndex={index}
        rowIndex={index}
        selectCell={selectCell}
        handleItemClick={handleItemClick}
        sourceForm={sourceForm}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.RowSpanCell.jsx